import { render, staticRenderFns } from "./GaaUser.vue?vue&type=template&id=3070109c&"
import script from "./GaaUser.vue?vue&type=script&lang=js&"
export * from "./GaaUser.vue?vue&type=script&lang=js&"
import style0 from "./GaaUser.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports